import type { TenantTheme } from '@/hooks/useTenant';
import { getCachedCapacity } from '@/lib/accountCapabilities';

/** typecompte réservé aux comptes vendeurs de marketplace. */
export const TYPE_COMPTE_VENDEUR = 9;

/** typecompte « Mixte ( Produit + Service) » — à ne pas confondre avec vendeur. */
export const TYPE_COMPTE_MIXTE = 7;

/** typecompte « Marketplace mixte produits et services » (cas 5). */
export const MARKETPLACE_MIXTE_TYPE_COMPTE = 15;
/** typecompte « Marketplace produits » (vue produits). */
export const MARKETPLACE_PRODUITS_TYPE_COMPTE = 13;
/** typecompte « Marketplace services » (vue services). */
export const MARKETPLACE_SERVICES_TYPE_COMPTE = 14;

/**
 * Détecte un compte marchand de type « marketplace » d'après son libellé
 * de type de compte (users.type) ou l'id du type de compte.
 */
export function isMarketplaceAccount(
  type?: string | null,
  typecompte?: number | null,
): boolean {
  const t = (type || '').toLowerCase();
  if (t.includes('marketplace') || t.includes('market place')) return true;
  const id = Number(typecompte);
  if (getCachedCapacity(id) === 'marketplace') return true;
  return (
    id === MARKETPLACE_MIXTE_TYPE_COMPTE ||
    id === MARKETPLACE_PRODUITS_TYPE_COMPTE ||
    id === MARKETPLACE_SERVICES_TYPE_COMPTE
  );
}

/**
 * Détecte la marketplace MIXTE (produits ET services) — cas 5 :
 * libellé « Marketplace mixte produits et services » ou id 15.
 */
export function isMarketplaceMixedAccount(
  type?: string | null,
  typecompte?: number | null,
): boolean {
  if (Number(typecompte) === MARKETPLACE_MIXTE_TYPE_COMPTE) return true;
  const t = (type || '').toLowerCase();
  return t.includes('marketplace') && t.includes('mix');
}

/**
 * Détecte si un thème est de type « marketplace ».
 * Un thème marketplace permet à plusieurs vendeurs de proposer leurs
 * annonces/produits sur le site, et à des clients de commander.
 */
export function isMarketplaceTheme(theme?: Partial<TenantTheme> | null): boolean {
  if (!theme) return false;
  const type = (theme.typetheme || '').toLowerCase();
  if (type.includes('marketplace') || type.includes('market place') || type.includes('marche')) {
    return true;
  }
  // Certains thèmes marketplace exposent une page dédiée 'marketplace'
  const pages = theme.visiblePages || [];
  return pages.includes('marketplace');
}